import {queryOptions} from '@tanstack/react-query';
import {api} from '@/libs/baseApi.client';
import type {ExperienceType} from '../type/experiences';

export const experienceTypesOptions = () =>
  queryOptions({
    queryKey: ['experience-types'],
    queryFn: async () => {
      try {
        const response = await api.get<ExperienceType[]>(`/ee/meta/types`);
        return response.data;
      } catch (error) {
        console.error('Failed to fetch experience by id:', error);
        return [];
      }
    },
    // Добавляем настройки для лучшей работы с SSG
    staleTime: 5 * 60 * 1000, // 5 минут
    retry: 1, // Только одна попытка повтора
  });
